import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { EnggDrawIP, SalesOrder, SaveStatusObj, SOModule, SaveEventType, ActualDateChange, ActualDateToken, PlannedDateToken, ValidationItem, ValidationSummary, SSOStatus, GenFileUploads } from '../../../shared/misc-classes';
import { DataService } from '../../../shared/dataservice.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActualDateDialog } from '../../../dialogs/actual-date-dialog/actual-date-dialog';
import { ValidationDialog } from '../../../dialogs/validation-dialog/validation-dialog';

@Component({
  selector: 'engg-draw',
  templateUrl: './engg-draw.component.html',
  styleUrls: ['./engg-draw.component.css']
})
export class EnggDrawComponent implements OnInit, OnChanges {

  @Input() enggDrawObj: EnggDrawIP;
  @Input() soLockObtained:boolean;
  @Input() loadCounter:SalesOrder;
  @Output() updateSubSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  @Output() showFileManager: EventEmitter<GenFileUploads> = new EventEmitter();
  disableForm: boolean = true;
  public _SSOStatus = SSOStatus;

  modifyPlanDate:boolean = false;
  modifyReqDate:boolean = false;
  inputDisableMessage:string = 'NA';
  
  Hvr:any = {};

  constructor(public _dataService: DataService,public dialog: MatDialog) { }

  ngOnInit() {
    this.modifyPlanDate = this._dataService.modifyPlanDate;
    this.modifyReqDate = this._dataService.modifyReqDate;
    this.ngOnChanges();
  }
  ngOnChanges() {
    this.disableForm = true;
    if(this.soLockObtained == false){
      this.inputDisableMessage = "You can't Edit, Sale Order Lock NOT obtained.";
    }
    // else if(!this.enggDrawObj.isProjectLive){
    //   this.inputDisableMessage = "Project is on HOLD or TO BE CANCELLED";
    // }
    else if(!this.enggDrawObj.isInputEnabled){
      this.inputDisableMessage = "This form is not yet enabled.";
    }
    else if(!this._dataService.hasEnggDrawingEditAccess(this.enggDrawObj)){
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else{
      this.disableForm = false;
    }
    this.enggDrawObj.sldGtpUploads.disableUpload = this.disableForm;
    this.enggDrawObj.sldGtpUploads.headerStr = 'SLD Submission Uploads' + " - " + this.enggDrawObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggDrawObj.parentSubSORef.subOrderNoId;
    this.enggDrawObj.revSldGtpUploads.disableUpload = this.disableForm;
    this.enggDrawObj.revSldGtpUploads.headerStr = 'Revised SLD/Scheme/GTP Calculation Uploads'  + " - " + this.enggDrawObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggDrawObj.parentSubSORef.subOrderNoId;
    this.enggDrawObj.schemeUploads.disableUpload = this.disableForm;
    this.enggDrawObj.schemeUploads.headerStr = 'Schematic Drawing & BOM Submission Uploads' + " - " + this.enggDrawObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggDrawObj.parentSubSORef.subOrderNoId;
    this.enggDrawObj.gafMgaUploads.disableUpload = this.disableForm;
    this.enggDrawObj.gafMgaUploads.headerStr = 'GA Foundation/Cross section/MGA Uploads' + " - " + this.enggDrawObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggDrawObj.parentSubSORef.subOrderNoId;
    this.enggDrawObj.revGafMgaUploads.disableUpload = this.disableForm;
    this.enggDrawObj.revGafMgaUploads.headerStr = 'Revised GA Foundation/Cross section/MGA Uploads' + " - " + this.enggDrawObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggDrawObj.parentSubSORef.subOrderNoId;
  }
  saveSso(_submitToNextSection:boolean,ssoSubmitTo:SSOStatus = SSOStatus.Not_Started){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, 
          (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data),
          null,
          ssoSubmitTo
        ));
    }
  }
  saveSsoo(_submitToNextSection:boolean,ssoSubmitTo:SSOStatus = SSOStatus.PM_Tech_EnggDraw | SSOStatus.SCM){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, 
          (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data),
          null,
          ssoSubmitTo
        ));
    }
  }
  deleteSSo(_deleteSO:boolean){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Delete_SubSale_Order));
    }
  }

  actualDateChangeHandler(_actDateHeader:string,_actDate:Date,_actDateChanged:Date,_actTokenKeyName:string,_plndDateHeader:string,_plndDate:Date,):void{
    let _actDateChangeObj:ActualDateChange = new ActualDateChange("Additional Comment", _plndDateHeader, _plndDate, _actDateHeader, 
                                                              _actDateChanged, this.enggDrawObj[_actTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _actDateChangeObj
    });
    let _prevActualDate:Date = this.enggDrawObj[_actTokenKeyName].actualDate;
    this.enggDrawObj[_actTokenKeyName].actualDate = _actDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.enggDrawObj[_actTokenKeyName].actualDate = _actDateChangeObj.actualDate;

        var changedDate: Date = null;
        if(_actDateChangeObj.actualDate != null){
          changedDate = new Date(_actDateChangeObj.actualDate.getTime());
        }

        this.enggDrawObj[_actTokenKeyName] = 
          new ActualDateToken(changedDate, true, _plndDate, _actDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.enggDrawObj[_actTokenKeyName].actualDate = _prevActualDate;
      }
    });
  }

  plannedDateChangeHandler(_plndDateHeader:string, _plndTokenKeyName:string,_plndDate:Date,_plndDateChanged:Date):void{
    let _plndDateChangeObj:ActualDateChange = new ActualDateChange("Why is the planned date changed ?", _plndDateHeader + "(existing)", 
                                                  _plndDate, _plndDateHeader + "(edited)", _plndDateChanged, this.enggDrawObj[_plndTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.enggDrawObj[_plndTokenKeyName].plannedDate = _plndDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.enggDrawObj[_plndTokenKeyName] = 
          new PlannedDateToken(new Date(_plndDateChanged.getTime()), true, null, _plndDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.enggDrawObj[_plndTokenKeyName].plannedDate = _plndDate;
      }
    });
  }
  showSsoPMTechValidation() {
    let _validList: Array<ValidationItem> = [];
    _validList.push(new ValidationItem("Technical CT details from Engg to PM Actual", (this.enggDrawObj.ctFinalizationGivenByEnggToPMActualDate ? true : false), " required for PM Tech & SCM."));

    if (this.enggDrawObj.isSplMatPapplicable) {
      _validList.push(new ValidationItem("Special price Mat Price Finalization Actual Date is Required ", (this.enggDrawObj.splMatActualDate ? true : false), " required for PM Tech."));
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });

  }

  showSsoEnggProcValidation(){
    let _validList:Array<ValidationItem> = [
      new ValidationItem("SLD & GA Approval Actual", (this.enggDrawObj.actualSLDGAApprovalDate ? true : false) ," required to move to Engg procurement." )    
    ] ;

    let vSummaryObj:ValidationSummary = new ValidationSummary("Validation Summary.",_validList);
    
    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }

  datasheetSaveLockValidation() {
    let _validList: Array<ValidationItem> = [];
    if(!this.enggDrawObj.parentSORef.marketingIP.electricalEnggHandoverDetails.handoverStatus && !this.enggDrawObj.parentSORef.marketingIP.mechanicalEnggHandoverDetails.handoverStatus && this.enggDrawObj.parentSORef.hasDatasheetInSO){
      _validList.push(new ValidationItem("Electrical Engineering Handover Approval", (this.enggDrawObj.parentSORef.marketingIP.electricalEnggHandoverDetails.handoverStatus ? true : false), "for Datasheet is required."));
      _validList.push(new ValidationItem("Mechanical Engineering Handover Approval", (this.enggDrawObj.parentSORef.marketingIP.mechanicalEnggHandoverDetails.handoverStatus ? true : false), "for Datasheet is required."));
    }
    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    // console.log(_validList);
    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }

  reloadData() {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Reload_Data));
    }
  }

  SLDGTPUploadsFileManagerClick(_evnt:any){
    _evnt.stopPropagation();//stop ref
    this.showFileManager.emit(this.enggDrawObj.sldGtpUploads);
  }
  RevSLDGTPUploadsFileManagerClick(_evnt){
    _evnt.stopPropagation();//stop ref
    this.showFileManager.emit(this.enggDrawObj.revSldGtpUploads);
  }
  SchemeUploadsFileManagerClick(_evnt){
    _evnt.stopPropagation();//stop ref
    this.showFileManager.emit(this.enggDrawObj.schemeUploads);
  }
  GAFMGAUploadsFileManagerClick(_evnt){
    _evnt.stopPropagation();//stop ref
    this.showFileManager.emit(this.enggDrawObj.gafMgaUploads);
  }
  RevGAFMGAUploadsFileManagerClick(_evnt){
    _evnt.stopPropagation();//stop ref
    this.showFileManager.emit(this.enggDrawObj.revGafMgaUploads);
  }
}
